module.exports = __webpack_public_path__ + "media/images/konintodoke/printout/google-play-badge-7d621b3544ad9fb175c14de54f305108.png";